import { MobileNumberCard } from './view';

export { default as MobileNumberReducer } from './reducer';
export { default as MobileNumberSaga } from './saga';

export default MobileNumberCard;
